import { useRecordManagerContext } from 'features/views/RecordManager/useRecordManagerContext'

export function useRecordManagerFieldValue<T>(fieldApiName: string): T | undefined {
    const { record } = useRecordManagerContext()

    return record?.[fieldApiName] ?? undefined
}
